import type { IVRInfo } from "../../../../sales-context/SalesContext.types";
import type { CallIntroStep } from "../../../../stores/useCallIntroStore";
import type { CustomerVerificationStep } from "../../../../stores/useVerificationFlowStore";

export function isIVRHandoffStep({
    callIntroStep,
    stepHistory,
    isEnhancedCustomerSearchEnabled,
    ivrInfo,
}: {
    callIntroStep: CallIntroStep;
    stepHistory: CustomerVerificationStep[];
    isEnhancedCustomerSearchEnabled: boolean;
    ivrInfo?: IVRInfo;
}) {
    const isSaasIVRHandoffStep = isEnhancedCustomerSearchEnabled && callIntroStep === "CustomerInfoCollection";
    const isStandardIVRHandoffStep =
        !isEnhancedCustomerSearchEnabled && stepHistory.at(stepHistory.length - 1) === "CustomerPhoneInput";
    const isConversationalIVRHandoffStep =
        !!ivrInfo?.conversationalSummary && stepHistory.at(stepHistory.length - 1) === "CustomerHandoff";
    return (
        (isSaasIVRHandoffStep && !!ivrInfo?.intent) ||
        (isStandardIVRHandoffStep && hasStandardIVRInfo(ivrInfo)) ||
        isConversationalIVRHandoffStep
    );
}

export function hasStandardIVRInfo({
    intent,
    device,
    summary,
    productLink,
    conversationalSummary,
}: IVRInfo = {}): boolean {
    return (!!intent || !!device || !!summary || !!productLink) && !conversationalSummary;
}
